<template lang="pug">
  .event-quiz
    flip-card(
      @flip="onFlip"
      :disabled="state === states.answer || state === states.done || state === states.finished"
      )
      template(v-slot:front)
        event-card-back(
          v-if="state === states.start"
          :event="quiz.event"
        )
        card-back(v-else)
          quiz-answer(@done="result => updateState(states.done, result)")
      template(v-slot:back)
        event-card-front(
          :event="quiz.event"
          :showElement="true"
        )
        //- :showElement="state === states.showElement"
</template>

<script>
import FlipCard from './FlipCard'
import CardBack from './CardBack'
import EventCardFront from './EventCardFront'
import EventCardBack from './EventCardBack'
import QuizAnswer from './QuizAnswer'

const states = {
  start: 0,
  showEvent: 1,
  showElement: 2,
  answer: 3,
  done: 4,
  finished: 5
};

export default {
  components:{
    FlipCard,
    CardBack,
    EventCardFront,
    EventCardBack,
    QuizAnswer
  },
  props: {
    quiz: Object
  },
  data() {
    return {
      states,
      state: states.start
    };
  },
  methods: {
    onFlip({ flipped }) {
      if (flipped && this.state === this.states.start) {
        this.updateState(this.states.showElement);
      }
      if (!flipped && this.state === this.states.showElement) {
        this.updateState(this.states.answer);
      }
    },
    updateState(state, value=null) {
      if (this.state === this.states.finished) {
        return;
      }
      this.state = state;
      if (this.state === this.states.done) {
        this.$emit('done', this.quiz, value);
        this.state = this.states.finished;
      }
    }
  },
  watch: {
    quiz: function (newQuiz, oldQuiz) {
      if (newQuiz.id !== oldQuiz.id) {
        this.state = this.states.start;
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
</style>
